<template>
  <component
    class="custom-logo"
    :is="customization_logo_url ? 'a' : 'div'"
    v-if="customization_logo"
    v-bind="customization_logo_url ? { href: customization_logo_url, target: '_blank' } : {}"
  >
    <img class="custom-logo__image" :src="customization_logo" alt="" />
  </component>
</template>

<script>
import {get_config} from "@src/utilities"

export default {
  name: 'custom-logo',

  props: {
  },

  data() {
    return {
    }
  },

  computed: {

    customization_logo: () => get_config('guiSettings.customizations.logo', false),
    customization_logo_url: () => get_config('guiSettings.customizations.logoUrl', ''),

  },

  created() {
  },

  mounted() {
  },
}
</script>

<style lang="scss" scoped>

  .custom-logo {
    width: min(110px, 30vw);
    height: 35px;
    display: flex;
    align-items: center;

    &__image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

</style>